
class BaseSurvey {
  constructor({
    surveyId = '',
    surveyName = '',
    surveyTitle = '',
    source = 'GCS',
    folder = '',
    apiKey = '',
    variantActiveByDefault = true,
    useCaptions = false,
    captionFormat = null,
    captionJsonField = null,
    variantFields = [],
    comparisonScheme = "all_pairs",
    referenceVariantName = null,
    createdBy = null,
    createdAt = null
  } = {}) {
    this.surveyId = surveyId;
    this.surveyName = surveyName;
    this.surveyTitle = surveyTitle;
    this.source = source;
    this.folder = folder;
    this.apiKey = apiKey;
    this.variantActiveByDefault = variantActiveByDefault;
    this.useCaptions = useCaptions;
    this.captionFormat = captionFormat;
    this.captionJsonField = captionJsonField;
    this.variantFields = variantFields;
    this.comparisonScheme = comparisonScheme || "all_pairs";
    this.referenceVariantName = referenceVariantName || null;
    this.createdBy = createdBy;
    this.createdAt = createdAt;
  }
}

export default BaseSurvey;